import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HighchartComponent } from './highchart.component';

@NgModule({
  declarations: [HighchartComponent],
  exports: [
    HighchartComponent
  ],
  imports: [
    CommonModule
  ]
})
export class HighchartModule { }
